<template>
  <div>
    <v-container grid-list-md>
      <v-layout row wrap>
        <v-flex lg12 md12 xl12 xs12>
          <v-card>
            <v-card-title primary-title>
              <h2 class="headline mb-0">Kategorie {{ category.title }}</h2>
            </v-card-title>
            <v-card-text>
              <v-layout row wrap>
                <v-flex lg7 md7 xl7 xs12>
                  <v-container grid-list-md>
                    <v-layout row wrap>
                      <v-flex xs12 sm6><v-text-field label="Name" v-model="category.title"></v-text-field></v-flex>
                      <v-flex xs12 sm6><v-text-field label="Maximale Teilnehmerzahl" v-model="category.maxParticipants" hint="Die maximale Teilnehmerzahl für die Buchungsseite kann hier definiert werden. Intern kann eine Kategorie überbucht werden."></v-text-field></v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12><h3>Startnummern</h3>
                        <p>Für die Validierung der Startnummern bei der Anmeldung kann hier ein Startnummern Bereich in der Kategorie definiert werden. Startnummernbereiche unter den Kategorien können sich überschneiden. Dort findet keine Validierung statt.</p></v-flex>
                      <v-flex xs6><v-text-field label="Startnummer - Minimum" v-model="category.startNumberMin"></v-text-field></v-flex>
                      <v-flex xs6><v-text-field label="Startnummer - Maximum" v-model="category.startNumberMax"></v-text-field></v-flex>
                    </v-layout>
                    <v-layout row>

                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <h3>Startzeit</h3>
                        <p class="caption">Die Startzeit kann hier manuell überschrieben werden.</p>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-date-picker v-model="startDate" :first-day-of-week="1" locale="de-DE" landscape color="secondary" :min="event.startDate"></v-date-picker>
                      </v-flex>
                      <v-flex xs12 md6>
                        <v-time-picker v-model="startTime" landscape format="24hr" color="secondary"></v-time-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
                <v-flex lg5 md5 xl5 xs12 v-if="id > 0">
                  <v-container grid-list-md>
                    <v-layout row>
                      <v-flex xs12><h3 class="subheadline">Versorgungspunkte</h3></v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs12>
                        <v-timeline dense>
                          <v-timeline-item v-for="(checkpoint, index) in category.checkpoints" :color="getCheckpointColor(index)" :key="index">
                            <v-btn @click="removeCheckpoint(index)" icon><v-icon color="error">fal fa-trash</v-icon>
                            </v-btn>
                            {{ checkpoint.title }}
                          </v-timeline-item>
                        </v-timeline>
                      </v-flex>
                    </v-layout>
                    <v-layout row>
                      <v-flex xs8>
                        <v-select :items="checkpoints" item-text="title" v-model="checkpointToAdd" :return-object="true"></v-select>
                      </v-flex>
                      <v-flex xs4>
                        <v-btn @click="addCheckpoint()"><v-icon left>fal fa-plus</v-icon> Hinzufügen</v-btn>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-btn color="primary" :to="{name: 'categories'}">
                Abbrechen
              </v-btn>
              <v-btn color="primary" @click="saveCategory()">
                Speichern
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar v-model="snackbar.display" bottom right :color="snackbar.color">
      {{ snackbar.message }}
      <v-btn flat @click="snackbar.display = false">
        <v-icon>fal fa-times</v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
  export default {
    props: ['id'],
    computed: {
      event() {
        return this.$store.state.event
      },
      category() {
        const category =  this.$store.state.categories.find(item => item.id === parseInt(this.id))
        if (category !== undefined) {
          return category
        }

        return {
          title: '',
          checkpoints: [],
          startNumberMin: null,
          startNumberMax: null
        }
      },
      categories() {
        return this.$store.state.categories
      },
      checkpoints() {
        return this.$store.state.checkpoints
      },
    },
    data: function () {
      return {
        startDate: null,
        startTime: null,
        checkpointToAdd: null,
        snackbar: {
          display: false,
          message: '',
          color: 'success'
        },
        rules: {
          required: value => !!value || 'Pflichtfeld',
          streetNumber: value => {
            const pattern = /^[0-9]+[ a-zA-Z]{0,2}$/
            return pattern.test(value) || 'Keine korrekte Hausnummer'
          },
          numberOnly: value => {
            const pattern = /^[0-9]+$/
            if (value === undefined || value === '') {
              return true
            } else if (pattern.test(value) && value > 0) {
              return true
            }
            return 'Bitte geben Sie nur Zahlen >= 1 ein.'
          },
          email: value => {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            return pattern.test(value) || 'Bitte geben Sie eine gültige E-Mailadresse ein.'
          }
        }
      }
    },
    methods: {
      addCheckpoint () {
        if (this.checkpointToAdd !== null) {
          this.category.checkpoints.push(this.checkpointToAdd)
        }
      },
      getCheckpointColor (index) {
        if (index === 0) {
          return 'error'
        } else if (index === (this.category.checkpoints.length - 1)) {
          return 'success'
        }

        return 'warning'
      },
      removeCheckpoint (index) {
        this.category.checkpoints.splice(index, 1)
      },
      saveCategory () {
        if (this.startDate !== null && this.startTime !== null) {
          this.category.startTime = this.startDate  + ' ' + this.startTime
        }
        this.$store.dispatch('updateCategory', this.category)
      }
    }
  }
</script>
